import { Reveal } from "@/components/Motion";
import { SectionLabel } from "@/components/SectionLabel";
import { Link } from "react-router-dom";

export const Intro = () => (
  <section className="py-24 sm:py-36" aria-labelledby="intro-heading" data-testid="home-intro">
    <div className="shell grid gap-10 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <SectionLabel index="01">Introduction</SectionLabel>
      </div>
      <div className="lg:col-span-8">
        <Reveal>
          <h2 id="intro-heading" className="font-display text-3xl font-bold leading-[1.15] tracking-[-0.03em] text-navy sm:text-4xl lg:text-[3.1rem]">
            Every business has something to say. <span className="text-royal">Thoughtful design</span> makes sure it is said clearly, consistently and memorably.
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-8 sm:grid-cols-2">
          <Reveal delay={0.1}>
            <p className="text-base leading-relaxed text-slatey sm:text-lg">
              PRPO LTD is a UK-based creative design company specialising in graphic design, branding, visual identity, packaging, and web and digital design.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-base leading-relaxed text-slatey sm:text-lg">
              Your logo, your packaging, your brochure and your website are often the first conversation a customer has with you. We design them to work together.{" "}
              <Link to="/about" className="font-semibold text-royal underline decoration-lime decoration-2 underline-offset-4 hover:text-navy" data-testid="intro-about-link">About PRPO LTD</Link>
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
